import styled, { css, keyframes } from "styled-components";
import { colors } from "../../utils";
import { device } from "../../utils/device";

export const HeaderMainDiv = styled.div`
  width: 100vw;
  height: 8vh;
  min-height: 60px;
  display: flex;
  justify-content: space-between;
  padding: 0.8vh 2vw;
  background-color: #ffffff;
  align-items: center;
  display: grid;
  grid-template-columns: 480px 1fr 480px;

  @media (${device.mobileLandscape}) {
    grid-template-columns: 220px 1fr 220px;
    height: 60px;
    transition: margin-top 0.3s ease-in-out;
    ${({ hide }) =>
      hide &&
      css`
        margin-top: -60px;
      `}
  }

  ${({ isMobileLandscape }) =>
    isMobileLandscape &&
    `
      height: 60px;
    transition: margin-top 0.3s ease-in-out;
    ${({ hide }) =>
      hide &&
      css`
        margin-top: -60px;
      `}
    `}
`;

export const LeftContainer = styled.div`
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const RightContainer = styled.div`
  height: 40px;
  display: flex;
  justify-content: flex-end;
`;

export const TitleDiv = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  position: relative;

  & p {
    margin: 0;
  }
`;

export const Title = styled.p`
  font-family: "DM Sans";
  font-size: 20px;
  font-weight: 700;
  line-height: 20px;
  text-align: center;
  color: #123051;
`;

export const Subtitle = styled.span`
  font-family: "DM Sans";
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  text-align: center;
  color: #565556;
`;

export const IconWrapper = styled.div`
  height: 42px;
  width: 42px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 16px;
  cursor: pointer;
  border-radius: 4px;
  padding: 8px;
  margin: 0px 3px;
  transition: box-shadow 0.2s ease;
  ${({ boolean }) =>
    boolean &&
    css`
      background-color: ${colors.background};
    `}


  &:hover {
    background-color: ${colors.background};
  }

  &:active {
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  }
`;

export const Icon = styled.img`
  width: 42px;
  height: 42px;
  cursor: pointer;
  width: 42px;
  height: 42px;
`;

export const AuthorContainer = styled.div`
  position: relative;
`;

const pulse = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.1);
  }
  100% {
    transform: scale(1);
  }
`;

export const Beta = styled.img`
  width: 70px;
  height: 32px;
  margin-right: 10px;
  cursor: pointer;

  /* Add the pulse animation */
  animation: ${pulse} 1.5s infinite;
`;
